import { useMutation, useQueryClient } from '@tanstack/react-query';
import { softDeleteConfig } from '../services/configs-api';

interface DeleteConfigParams {
  configId: string;
  reason: string;
}

/**
 * TanStack Mutation hook for soft-deleting a configuration object.
 * Invalidates the configs list cache on success.
 */
export function useDeleteConfig() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteConfigParams>({
    mutationFn: ({ configId, reason }) => softDeleteConfig(configId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] });
    },
  });
}
